export function WeightIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Justice-Scale-1--Streamline-Core">
        <g id="justice-scale-1--office-work-scale-justice-company-arbitration-balance-court">
          <path
            id="Vector"
            d="M6.41922 10.6345L3.7853 4.83984L1.15137 10.6345M6.41922 10.6345C6.41922 11.333 6.14172 12.003 5.64777 12.497C5.15381 12.9909 4.48386 13.2684 3.7853 13.2684C3.08674 13.2684 2.41678 12.9909 1.92282 12.497C1.42887 12.003 1.15137 11.333 1.15137 10.6345M6.41922 10.6345H1.15137"
            stroke={props.color || '#626266'}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M14.8479 10.6345L12.214 4.83984L9.58008 10.6345M14.8479 10.6345C14.8479 11.333 14.5704 12.003 14.0765 12.497C13.5825 12.9909 12.9125 13.2684 12.214 13.2684C11.5155 13.2684 10.8455 12.9909 10.3515 12.497C9.85758 12.003 9.58008 11.333 9.58008 10.6345M14.8479 10.6345H9.58008"
            stroke={props.color || '#626266'}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_3"
            d="M2.20508 4.83984H13.7944"
            stroke={props.color || '#626266'}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_4"
            d="M8 4.83956V2.73242"
            stroke={props.color || '#626266'}
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}

export default WeightIcon;
